import React from 'react'
//import GoogleLogin from 'react-google-login';
import { GoogleLogin } from '@react-oauth/google';
import jwt_decode from 'jwt-decode';
import { Navigate, useNavigate } from 'react-router-dom';
import { FcGoogle } from 'react-icons/fc';
import promptHavenLogo from '../assets/PromptHaven_Logo.png';
import promptHavenVideo from '../assets/PromptHaven_Bg.mp4'

import { client } from '../client';

const Login = () => {
  const navigate = useNavigate();
  const responseGoogle= (response) => {
  const googledecoded = jwt_decode(response.credential)

    localStorage.setItem('user',JSON.stringify(googledecoded))

    const { name, sub, picture, email } = googledecoded;

    const doc = {
      _id: sub,
      _type: 'user',
      userName: name,
      image: picture,
      email: email
    }

    client.createIfNotExists(doc)
      .then(() => {
          navigate('/',{ replace: true })
      })
  }

  return (

    
    <div className="flex justify-start items-center flex-col h-screen">
        <div className='relative w-full h-full'>
        <video
          src={promptHavenVideo}
          type="video/mp4"
          loop
          controls={false}
          muted
          autoPlay
          className="w-full h-full object-cover"
        />
          
          <div className='absolute flex flex-col justify-center items-center top-0 right-0 left-0 bottom-0 bg-blackOverlay'>
            {/* <div className='p-5'>
               <img src={promptHavenLogo} width='200px' alt='logo' /> 
            </div> */}
            <div >
              <h1 className="font text-6xl font-bold tracking-tight text-black-900 sm:text-6xl">
                prompthaven.
              </h1>
              <p className="text-xl flex justify-center items-center text-gray-100 mb-5">
                Your source for free AI art prompts
              </p>
            </div>
            <div className='shadow-2xl'>
              <GoogleLogin 
              render={(renderProps) => (
                <button 
                type='button' 
                className='bg-mainColor flex justify-center items-center p-3 rounded-lg cursor-pointer outline-none'
                onClick={renderProps.onClick}
                disabled={renderProps.disabled}>
                   <FcGoogle className="mr-4" /> Sign in with Google
                </button>
              )}
              onSuccess={responseGoogle}
              onFailure={responseGoogle}
              cookiePolicy="single_host_origin"
              />
            </div>


          </div>

        </div>
    </div>
  )
}

export default Login